module.exports = __webpack_public_path__ + "done.c1ecc549423c6071484fe60afb25de5d.png";